module.exports = __webpack_public_path__ + "img/peter-rybczyk.72de3cf1.jpg";